// en.js
export default {
  common: {
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    export:'Export',
    setLgSuccess: 'Set language successfully',
  },
  header: {
    "ourProduct": "Our Products",
    "appProduct": "UUPay APP",
    "posProduct": "UUPay Cash Register",
    "monitorProduct": "UUPay Console",
    "price": "Price",
    "resource": "Practical Resources",
    "blog": "Blog",
    "document": "Teaching Documents",
    "case": "Merchant Success Cases",
    "company": "Company",
    "aboutUs": "About Us",
    "job": "Job Opportunities",
    "contactUs": "Contact Us",
    "news": "Company News",
    "toDownload": "Use Now",
  },
  footer: {
    "address": "Room 001, 01/F, Building 1, 01 Plaza, Hong Kong",
    "news": "Media Reports",
    "privacy": "Privacy Policy",
    "privacyDetail": "Terms and Details",
    "copyright": "All Rights",
    "phone": "+110 1000 1000",
    "email": "UUPay123@.com",
    "about": "About",
    "cooperate": "Cooperation",
  },
  home: {
    
  }
}


// WEBPACK FOOTER //
// ./src/lang/en.js